import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { from, Observable, of, delay } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { catchError, switchMap } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import {
  AlunoComAnosLetivos,
  BoletimCompleto,
  RelatorioHtml,
  DisciplinaComAvaliacoes,
  CabecalhoBoletim,
  DisciplinaBoletim
} from '../models/portal.models';

/**
 * Serviço que simula chamadas ao backend
 * Posteriormente, basta substituir os métodos por chamadas HTTP reais
 */
@Injectable({
  providedIn: 'root'
})
export class PortalBackendService {

  private apiUrl = environment.apiPortalPais;
  constructor(private http: HttpClient) { }

  /**
   * GET /api/aluno/buscar-alunos
   * Retorna lista de alunos com seus anos letivos vinculados ao Aluno
   */
  getAlunosComAnosLetivos(): Observable<HttpResponse<any>> {
    return this.http.get<AlunoComAnosLetivos[]>(`${this.apiUrl}/api/aluno/buscar-alunos`, { observe: 'response' } );
  }


  /**
   * GET /api/boletim/{alunoId}/{anoId}
   * Retorna o boletim completo do aluno para o ano letivo especificado
   */
  getBoletim(alunoId: number, anoLetivoId: number, turmaId: number): Observable<HttpResponse<any>> {
    return this.http.get<BoletimCompleto[]>(`${this.apiUrl}/api/boletim/${alunoId}/${anoLetivoId}/${turmaId}`, { observe: 'response' } );
  }

  /**
   * GET /api/Avaliacoes/buscar-avaliacoes/{alunoId}/{anoLetivoId}
   * Retorna as avaliações realizadas desse aluno para o ano letivo selecionado
   */
  getAvaliacoes(alunoId: number, anoLetivoId: number): Observable<DisciplinaComAvaliacoes[]> {
      return this.http.get<DisciplinaComAvaliacoes[]>(`${this.apiUrl}/api/avaliacoes/buscar-avaliacoes/${alunoId}/${anoLetivoId}` );
  }


  /**
   * Simula GET /api/relatorios/buscar-relatorio/${relatorioId}
   * Retorna o relatório do periodo solicitado
   */
  getRelatorioPeriodo(alunoId: number, criterioAvaliacaoId: number, turmaId: number, turmaDisciplinaId: number):Observable<HttpResponse<any>>{
    const params = { turmaId, turmaDisciplinaId };
    return this.http.get<[]>(`${this.apiUrl}/api/relatorio/${alunoId}/buscar-relatorio/${criterioAvaliacaoId}`,
    {params, observe: 'response' });
  }
}

